module.exports = __webpack_public_path__ + "static/media/logo.65c7f257.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 701
// module chunks = 0